import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';
import { activationDescriptionId } from './Content';

function Footer({ onActivationConfirm = () => null, confirmButtonRef = null }) {
  return (
    <div className="els-btn-group-right remote-access-dialog__footer">
      <Button
        innerRef={confirmButtonRef}
        data-e2e="remote-access-email-continue"
        type="primary"
        size="small"
        aria-describedby={activationDescriptionId}
        onClick={onActivationConfirm}
        className="e2e-remote-access-email-continue">
        Got it
      </Button>
    </div>
  );
}

Footer.propTypes = {
  onActivationConfirm: PropTypes.func,
  // The dialog focus trap focuses this button on open
  confirmButtonRef: PropTypes.object,
};

export default Footer;
